import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const name = "conversation";
const initialState = {
  conversation: "",
  loading: false,
  error: null,
};

export const selectConversation = createAsyncThunk(
  "conversation",
  async (id) => {
    return id;
  }
);

const selectConversationSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(selectConversation.fulfilled, (state, action) => {
      state.conversation = action.payload;
      state.loading = false;
      state.error = null;
    });
  },
});

export default selectConversationSlice.reducer;
